<h1 mat-dialog-title>
    Edit Schools in
    @if (data.scholarshipName == null) {
    <span>Scholarship</span>
    }
    @else {
    <span class="text-orange-400">{{data.scholarshipName}}</span>
    }
</h1>
<mat-dialog-content>
    <label>Participating Schools</label>
    <div>
        @for (school of selectedSchools; track school.SchoolNumber) {
        <div>
            <mat-checkbox [(ngModel)]="school.IsChecked" (ngModelChange)="onChange($event)">({{school.SchoolNumber}}) - {{school.SchoolName}}</mat-checkbox>
        </div>
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="flex flex-col">
        @if (submitted === true) {
        <div class="text-red-500">
            @if (formEdited === false) {
            <div>No changes detected</div>
            }
        </div>
        }
        <div>
            <button mat-raised-button type="button" (click)="closeDialog()">Cancel</button>
            <button mat-flat-button type="submit" (click)="submit()">Ok</button>
        </div>
    </div>
</mat-dialog-actions>